<template>
  <div class="image-upload">
    <el-upload
      action=""
      :accept="accept"
      :show-file-list="false"
      :http-request="upload"
    >
      <el-button size="small" icon="el-icon-upload2">{{ value ? '更换图片' : '上传图片' }}</el-button>
    </el-upload>
    <el-image
      v-if="value"
      class="image-upload-preview"
      :src="absolute(value)"
      :preview-src-list="[absolute(value)]"
      fit="contain"
    />
  </div>
</template>

<script>
import http, { absoluteUrl, MAX_UPLOAD_FILE_SIZE, UPLOAD_TIMEOUT } from '../api'

export default {
  props: {
    value: String,
    fileId: Number,
    accept: {
      type: String,
      default: 'image/*'
    },
    bizType: {
      type: String,
      default: 'common'
    }
  },
  methods: {
    absolute: absoluteUrl,
    async upload({ file }) {
      if (file.size > MAX_UPLOAD_FILE_SIZE) {
        this.$message.error('上传文件不能超过500MB')
        return
      }
      const dimensions = await this.readImageDimensions(file)
      const form = new FormData()
      form.append('file', file)
      form.append('bizType', this.bizType)
      const data = await http.post('/admin/files/upload', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: UPLOAD_TIMEOUT
      })
      this.$emit('input', data.url)
      this.$emit('update:fileId', data.id)
      this.$emit('dimensions', dimensions)
      this.$message.success('图片已上传')
    },
    readImageDimensions(file) {
      return new Promise(resolve => {
        const image = new Image()
        const objectUrl = URL.createObjectURL(file)
        image.onload = () => {
          URL.revokeObjectURL(objectUrl)
          resolve({ width: image.naturalWidth || null, height: image.naturalHeight || null })
        }
        image.onerror = () => {
          URL.revokeObjectURL(objectUrl)
          resolve({ width: null, height: null })
        }
        image.src = objectUrl
      })
    }
  }
}
</script>

<style scoped>
.image-upload-preview {
  width: 120px;
  height: 80px;
  margin-left: 12px;
  vertical-align: middle;
  background: #f4f7fb;
}
</style>
